import * as React from "react";
import { Column } from "primereact/column";
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { Link } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { DataTable } from "primereact/datatable";
import PageLayout from "../../components/PageLayout";
import useEntitiesList from "../../utils/listHookNew";
import { getDate, filterDate, DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { deleteVehicle } from "../../api/vehicles";
import { useAuth0 } from "../../auth/react-auth0-wrapper"
import classNames from 'classnames';
import { downloadFile, showfile } from "../../api/files"
import { getCollaudo } from "../../api/collaudo";

export default function VehicleList() {
    let dtable;
    const { domains } = useAuth0();

    const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("vehicles", "plate asc", "(col.status is NULL OR col.status<>'deleted') AND (t.status<>'deleted' OR t.status is NULL)", "");

    const [openModal, setOpenModal] = React.useState(false);
    const toggle = () => setOpenModal(!openModal);

    const onDelete = async id => {
        const value = await deleteVehicle(id);
        toggle();
        forceRefresh();
        return value;
    };

    async function download(idCollaudo) {
        try {
            setLoading(true);
            const collaudoRes = await getCollaudo(idCollaudo);
            const result = await downloadFile(collaudoRes.meta.docs[0].id);
            showfile(result, "application/pdf");
        } finally {
            setLoading(false);
        }
    }

    const modalSection = () => (
        <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
            <ModalHeader toggle={toggle}>
                Eliminazione Veicolo
      </ModalHeader>
            <ModalBody>
                <p>Confermi di voler eliminare il Veicolo con targa {openModal.plate}?</p>
            </ModalBody>
            <ModalFooter>
                <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
                <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
            </ModalFooter>
        </Modal>
    );

    const onRefresh = () => {
        forceRefresh();
        setGlobalFilter("");
    }

    const exportTable = () => {
        dtable.exportCSV();
    }

    return (
        <PageLayout title="Elenco Veicoli">
            <Row>
                <Col>
                    <DataTable
                        ref={el => {
                            dtable = el;
                        }}
                        loading={loading}
                        value={result}
                        rowsPerPageOptions={[5, 10, 20, 50, 100]}
                        className="p-datatable-hoverable-rows p-datatable-customers"
                        responsive
                        paginator={true}
                        autoLayout={false}
                        first={0}
                        rows={20}
                        totalRecords={result.length}
                        paginatorPosition="both"
                        header={renderHeader(loading, result.length, undefined, undefined, { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
                        globalFilter={globalFilter}
                        emptyMessage={() => (<div className="text-center">Nessun veicolo in tabella</div>)}
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                        currentPageReportTemplate="Visualizzati {first} di {last} Veicoli su un totale di {totalRecords}"
                    >
                        <Column
                            field="plate"
                            style={{ wordWrap: "break-word" }}
                            header="Targa"
                            sortable
                            filter
                            filterMatchMode="contains"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/vehicles/${rowData._id}`}
                                    >
                                        {rowData.plate.toUpperCase()}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="attributes.make"
                            style={{ wordWrap: "break-word" }}
                            header="Marca"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="attributes.model"
                            style={{ wordWrap: "break-word" }}
                            header="Modello"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="attributes.preparation"
                            style={{ wordWrap: "break-word" }}
                            header="Allestimento"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="km"
                            style={{ wordWrap: "break-word" }}
                            header="Km."
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="customer_name"
                            style={{ wordWrap: "break-word" }}
                            header="Cliente"
                            sortable
                            filter
                            filterMatchMode="contains"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/tenant/customers/${rowData.customer_id}`}
                                    >
                                        {rowData.customer_name}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="device_imei"
                            style={{ wordWrap: "break-word" }}
                            header="IMEI dispositivo"
                            sortable
                            filter
                            filterMatchMode="contains"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/backoffice/devices/${rowData.device_id}`}
                                    >
                                        {rowData.device_imei}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="simcards_number"
                            style={{ wordWrap: "break-word" }}
                            header="Tel. SIM"
                            sortable
                            filter
                            filterMatchMode="contains"
                            body={(rowData, column) => {
                                return (
                                    <Link
                                        to={`/backoffice/simcards/${rowData.simcards_id}`}
                                    >
                                        {rowData.simcards_number}
                                    </Link>
                                );
                            }}
                        />
                        <Column
                            field="attributes.canCode"
                            style={{ wordWrap: "break-word" }}
                            header="Codice CAN"
                            sortable
                            filter
                            filterMatchMode="contains"
                        />
                        <Column
                            field="collaudo_status"
                            style={{ wordWrap: "break-word" }}
                            header="Collaudo"
                            sortable
                            filter
                            filterMatchMode="contains"
                            filterElement={
                                <DropdownFilterElement
                                    field="collaudo_status"
                                    options={[
                                        { label: "inserito", value: "inserito" },
                                        { label: "firmato", value: "firmato" },
                                        { label: "da firmare", value: "giscomplete" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.collaudo_status)}>{rowData.collaudo_status !== 'giscomplete' ? rowData.collaudo_status : 'da firmare'}</span>
                                );
                            }}
                        />
                        <Column
                            field="collaudo_data"
                            header="Data collaudo"
                            sortable
                            filter
                            body={getDate}
                            filterMatchMode="custom"
                            filterFunction={filterDate}
                            style={{ wordWrap: "break-word" }}
                        />
                        <Column
                            field="ticket_status"
                            style={{ wordWrap: "break-word" }}
                            header="Ticket"
                            sortable
                            filter
                            filterMatchMode="contains"
                            filterElement={
                                <DropdownFilterElement
                                    field="ticket_status"
                                    options={[
                                        { label: "aperto", value: "aperto" },
                                        { label: "chiuso", value: "chiuso" }
                                    ]}
                                    onChange={e => dtable.filter(e.value, e.field)}
                                />
                            }
                            style={{ wordWrap: "break-word", textAlign: "center" }}
                            body={(rowData, column) => {
                                return (
                                    <span className={classNames('customer-badge', 'status-' + rowData.ticket_status)}>{rowData.ticket_status}</span>
                                );
                            }}
                        />
                        <Column
                            field="actions"
                            body={(rowData, column) => {
                                return (
                                    <div className="action-container">
                                        <Link
                                            title="Gestisci veicolo"
                                            className="btn btn-sm btn-primary p-button-icon-only mr-1"
                                            to={`/tenant/vehicles/${rowData._id}`}
                                        >
                                            <FontAwesomeIcon icon="pencil-alt" />
                                        </Link>
                                        <Can
                                            roles={[roles.ADMIN]}
                                            yes={() => (
                                                <Button
                                                    color="danger"
                                                    title="Elimina veicolo"
                                                    onClick={() => setOpenModal(rowData)}
                                                    className="btn-sm p-button-icon-only mr-1"
                                                >
                                                    <FontAwesomeIcon icon="trash-alt" />
                                                </Button>
                                            )}
                                            no={() => null}
                                        />
                                        {rowData.collaudo_status === "firmato" && (<Button
                                            disabled={loading}
                                            color="secondary"
                                            onClick={() => download(rowData.collaudo_id)}
                                            className="btn-sm p-button-icon-only mr-1"
                                        >
                                            <FontAwesomeIcon icon="file-pdf" />
                                        </Button>
                                        )}
                                    </div>
                                );
                            }}
                            style={{ wordWrap: "break-word" }}
                        />
                    </DataTable>
                </Col>
            </Row>
            {modalSection()}
        </PageLayout >
    );
}
